import { Component, OnInit, Input } from '@angular/core';

/** This is the generic component which will have form controls in it**/
@Component({
  selector: 'generic-form-window',
  templateUrl: './generic-form-window.component.html',
  styleUrls: ['../widgets-custom-theme.scss', './generic-form-window.component.scss']
})
export class GenericFormWindowComponent implements OnInit {

  constructor() { }

  @Input('window-title') windowTitle: string = 'Default title';
  @Input('card-icon-available') cardIconAvailable: boolean = true;
  @Input('cardTwoVisible') cardTwoVisible: boolean = false; 
  @Input('card-top-icon') cardTopIcon: string = '';
  @Input('cardTwoTopIcon') cardTwoTopIcon: string = '';
  @Input('cardLayoutReverse') cardLayoutReverse: boolean = false;
  @Input('cardOneVisible') cardOneVisible: boolean = true;

  cardLayout: string = 'column';
  cardTwoIconAvailable: boolean = false;

  ngOnInit() {
    if (this.cardLayoutReverse)
      this.cardLayout = 'column-reverse';
    if (this.cardTwoTopIcon && this.cardTwoTopIcon.length > 0)
      this.cardTwoIconAvailable = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/widgets/generic-form-window/generic-form-window.component.ts